import React, { useState, useMemo, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetAllBrandsQuery } from '../../api/endpoints/brand';

const BrandDropdown = ({ value, onChange, className = '', disabled = false, placeholder = 'Marka seçiniz veya arayınız' }) => {
    const [searchText, setSearchText] = useState('');

    const { data: brandList = { items: [] }, isLoading } = useGetAllBrandsQuery({
        pageNumber: 0,
        pageSize: 9999,
        searchText: searchText
    });

    useEffect(() => {
        console.log('Brandlist:', brandList);
    }, [brandList]);

    const brandOptions = useMemo(() => {
        return (
            brandList?.data?.items?.map((brand) => ({
                id: brand.id,
                brandShort: brand.brandShort,
                displayValue: brand.brandShort
            })) || []
        );
    }, [brandList]);

    useEffect(() => {
        console.log('brandOptions:', brandOptions);
    }, [brandOptions]);

    const selectedOption = useMemo(() => {
        if (!value) return null;
        return brandOptions.find((b) => b.id === value.id) || value;
    }, [value, brandOptions]);

    return (
        <Dropdown
            value={selectedOption}
            options={brandOptions}
            onChange={(e) => onChange(e.value)}
            onFilter={(e) => setSearchText(e.filter)}
            optionLabel="displayValue"
            filter
            showClear
            filterBy="id,brandShort"
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            virtualScrollerOptions={{ itemSize: 38 }}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.brandShort}</span>
                </div>
            )}
        />
    );
};

export default BrandDropdown;
